// extracted by mini-css-extract-plugin
module.exports = {"sunPosition":"SunPositionView_sunPosition__9fV0v","sunPath":"SunPositionView_sunPath__e1a7T","sunLabel":"SunPositionView_sunLabel__FSC6k"};